import Vue from 'vue'

import Qs from 'qs'

class Applications {
  async indexEvent({eventId, params}) {
    return await Vue.axios
      .get('app/applications-by-event/' + eventId, {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async indexVolunteer({volunteerId, params}) {
    return await Vue.axios
      .get('app/applications-by-volunteer/' + volunteerId, {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async read({id}) {
    return await Vue.axios
      .get('app/applications/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/applications/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/applications/' + id)
  }
}

const applications = new Applications()

export default applications
